import React from 'react';
import './IconSelector.css';
import beerIcon from '../../../assets/shared/collection_icons/beer.svg';
import coffeeIcon from '../../../assets/shared/collection_icons/coffee.svg';
import cocktailIcon from '../../../assets/shared/collection_icons/martini-glass-citrus.svg';
import cupcakeIcon from '../../../assets/shared/collection_icons/cupcake.svg';
import drinkIcon from '../../../assets/shared/collection_icons/drink-alt (1).svg';
import fishIcon from '../../../assets/shared/collection_icons/fish (1).svg';
import friesIcon from '../../../assets/shared/collection_icons/french-fries.svg';
import hamburgerIcon from '../../../assets/shared/collection_icons/hamburger.svg';
import iceCreamIcon from '../../../assets/shared/collection_icons/ice-cream (1).svg';
import lobsterIcon from '../../../assets/shared/collection_icons/lobster.svg';
import meatIcon from '../../../assets/shared/collection_icons/meat.svg';
import noodlesIcon from '../../../assets/shared/collection_icons/bowl-chopsticks-noodles.svg';
import pastaIcon from '../../../assets/shared/collection_icons/farfalle.svg';
import pizzaIcon from '../../../assets/shared/collection_icons/pizza-slice.svg';
import popcornIcon from '../../../assets/shared/collection_icons/popcorn.svg';
import saladIcon from '../../../assets/shared/collection_icons/salad (1).svg';
import shrimpIcon from '../../../assets/shared/collection_icons/shrimp.svg';
import soupIcon from '../../../assets/shared/collection_icons/soup.svg';
import steakIcon from '../../../assets/shared/collection_icons/steak.svg';
import sushiIcon from '../../../assets/shared/collection_icons/sushi.svg';
import turkeyIcon from '../../../assets/shared/collection_icons/turkey (1).svg';
import wineIcon from '../../../assets/shared/collection_icons/wine-glass-empty.svg';
import croissantIcon from '../../../assets/shared/collection_icons/croissant.svg';
import boxIcon from '../../../assets/shared/collection_icons/box.svg';

const icons = [
    { id: 1, name: "Algemeen", icon: meatIcon },
    { id: 2, name: "Voorgerechten", icon: shrimpIcon },
    { id: 3, name: "Hoofdgerechten", icon: steakIcon },
    { id: 4, name: "Desserts", icon: cupcakeIcon },
    { id: 5, name: "Dranken", icon: drinkIcon },
    { id: 6, name: "Wijn", icon: wineIcon },
    { id: 7, name: "Bier", icon: beerIcon },
    { id: 8, name: "Cocktails", icon: cocktailIcon },
    { id: 9, name: "Koffie & Thee", icon: coffeeIcon },
    { id: 10, name: "Pizza", icon: pizzaIcon },
    { id: 11, name: "Pasta & Noedels", icon: pastaIcon },
    { id: 12, name: "Aziatisch", icon: noodlesIcon },
    { id: 13, name: "Sushi", icon: sushiIcon },
    { id: 14, name: "Burgers", icon: hamburgerIcon },
    { id: 15, name: "Frietjes & Snacks", icon: friesIcon },
    { id: 16, name: "Salades", icon: saladIcon },
    { id: 17, name: "Soepen", icon: soupIcon },
    { id: 18, name: "Ontbijt & Brunch", icon: croissantIcon },
    { id: 19, name: "Vis & Schaaldieren", icon: fishIcon },
    { id: 20, name: "Gevogelte", icon: turkeyIcon },
    { id: 21, name: "Vlees", icon: meatIcon },
    { id: 22, name: "IJs & Desserts", icon: iceCreamIcon },
    { id: 23, name: "Kreeft & Schaaldieren", icon: lobsterIcon },
    { id: 24, name: "Snacks & Popcorn", icon: popcornIcon },
    { id: 25, name: "Boxen", icon: boxIcon }
];

const IconSelector = ({ selectedIcon, onSelectIcon }) => {
    return (
        <div className="icon-selector">
            <label className="icon-selector-label">Kies een icoon</label>
            <div className="icon-grid">
                {icons.map((icon) => (
                    <button
                        key={icon.id}
                        type="button"
                        className={`icon-button ${selectedIcon === icon.icon ? 'selected' : ''}`}
                        onClick={() => onSelectIcon(icon.icon)}
                    >
                        <img src={icon.icon} alt={icon.name} className="icon-image" />
                        <span className="icon-name">{icon.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default IconSelector; 